import { createRouter, createWebHistory } from 'vue-router';
// @ts-ignore
import { isProductionDomain } from '@/plugins/axios';

import DraftView from '@/view/DraftView.vue';
import InvoiceFirstPageView from '@/view/InvoiceFirstPageView.vue';
import PartnerLinkView from '@/view/PartnerLinkView.vue';
import PartnerLinkShowcaseView from '@/view/PartnerLinkShowcaseView.vue';
import PayView from '@/view/PayView.vue';
import FailView from '@/view/FailView.vue';
import SuccessView from '@/view/SuccessView.vue';
import LandingView from '@/view/LandingView.vue';
import DirectCreditWidgetView from '@/view/DirectCreditWidgetView.vue';

const routes = {
  production: [
    {
      path: '/',
      name: 'landing',
      component: LandingView
    },
    {
      path: '/d/:uuid?',
      name: 'draftInvoice',
      component: DraftView
    },
    {
      path: '/i/:uuid',
      name: 'invoiceFirstPage',
      component: InvoiceFirstPageView
    },
    {
      path: '/direct-credit/widget',
      name: 'directCreditWidget',
      component: DirectCreditWidgetView
    },
    {
      path: '/l/showcase',
      name: 'partnerLinkShowcase',
      component: PartnerLinkShowcaseView
    },
    {
      path: '/l/showcase/:draftInvoiceId',
      name: 'partnerLinkShowcaseProduct',
      component: PartnerLinkShowcaseView
    },
    {
      path: '/l/:uuid',
      name: 'partnerLink',
      component: PartnerLinkView
    },
    {
      path: '/:uuid?',
      name: 'invoice',
      component: PayView
    },
    {
      path: '/fail',
      name: 'fail',
      component: FailView
    },
    {
      path: '/success',
      name: 'success',
      component: SuccessView
    },
  ],
  development: [
    {
      path: '/:parther/',
      name: 'landing',
      component: LandingView
    },
    {
      path: '/:parther/d/:uuid?',
      name: 'draftInvoice',
      component: DraftView
    },
    {
      path: '/:parther/i/:uuid',
      name: 'partnerInvoiceFirstPage',
      component: InvoiceFirstPageView
    },
    {
      path: '/:parther/direct-credit/widget',
      name: 'directCreditWidget',
      component: DirectCreditWidgetView
    },
    {
      path: '/:parther/l/showcase',
      name: 'partnerLinkShowcase',
      component: PartnerLinkShowcaseView
    },
    {
      path: '/:parther/l/showcase/:draftInvoiceId',
      name: 'partnerLinkShowcaseProduct',
      component: PartnerLinkShowcaseView
    },
    {
      path: '/:parther/l/:uuid',
      name: 'partnerLink',
      component: PartnerLinkView
    },
    {
      path: '/:parther/:uuid?',
      name: 'invoice',
      component: PayView
    },
    {
      path: '/:parther/fail',
      name: 'fail',
      component: FailView
    },
    {
      path: '/:parther/success',
      name: 'success',
      component: SuccessView
    },
  ]
}

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: isProductionDomain() ? routes.production : routes.development
})

export default router
